import { render, staticRenderFns } from "./UpdateDocuments.vue?vue&type=template&id=13be21e2"
import script from "./UpdateDocuments.vue?vue&type=script&lang=js"
export * from "./UpdateDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports